// Module
var code = "You should return to the place you decided was 'home'... ";
// Exports
module.exports = code;